import React from "react";
import PropTypes from "prop-types";
import ReadOnlyField from "./ReadOnlyField";
import "./DocumentView.css";

const CommonView = ({
  folderName,
  title,
  autoNumber,
  registerDate,
  registrant,
  viewCount,
  onEdit,
  onCopy,
}) => {
  return (
    <div className="common-view">
      <div className="common-view__header">
        <button type="button" className="btn edit-btn" onClick={onEdit}>
          編集開始
        </button>
        <button type="button" className="btn copy-btn" onClick={onCopy}>
          コピー
        </button>
      </div>

      <ReadOnlyField label="フォルダー" value={folderName} />

      <div className="form-row common-view__title-row">
        <div style={{display: "flex", width: "100%"}}>
          <span className="form-label">タイトル</span>
            <div className="form-input-group common-view__title-group">
              <div className="form-value">{title}</div>
            </div>
        </div>

        <div className="auto-number-group read-only">
          <span className="form-label auto-number-label">オートナンバー</span>
          <span className="auto-number-value">{autoNumber}</span>
        </div>
        
      </div>

      <div className="common-view__grid">
        <div className="common-view__grid-column">
          <ReadOnlyField label="登録日時" value={registerDate} />
        </div>
        <div className="common-view__grid-column">
          <ReadOnlyField label="登録者" value={registrant} />
          <ReadOnlyField label="参照回数" value={viewCount} />
        </div>
      </div>
    </div>
  );
};

CommonView.propTypes = {
  folderName: PropTypes.string,
  title: PropTypes.string,
  autoNumber: PropTypes.string,
  registerDate: PropTypes.string,
  registrant: PropTypes.string,
  viewCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onEdit: PropTypes.func,
  onCopy: PropTypes.func,
};

CommonView.defaultProps = {
  folderName: "",
  title: "",
  autoNumber: "",
  registerDate: "",
  registrant: "",
  viewCount: "",
  onEdit: () => {},
  onCopy: () => {},
};

export default CommonView;
